import connect from './connect';
import TemplateLengthSelectorModal from './TemplateLengthSelectorModal';

export default connect(TemplateLengthSelectorModal);
export { TemplateLengthSelectorModalProps } from './TemplateLengthSelectorModal';
